import { type MbscResource } from '@mobiscroll/react';

import { Location } from '../../../../../dtos.js';
import { CalendarResourceType } from '../calendarResourceTypes.js';

export class LocationResource<T extends MbscResource> implements MbscResource {
  public readonly id: `location-${string}`;

  public readonly name: string;

  public readonly background: string;

  public readonly children: T[];

  public readonly seminarrundenAuslastung: Location['seminarrundenAuslastung'];

  public readonly calendarResourceType: CalendarResourceType;

  public constructor(location: Location, calendarResourceType: CalendarResourceType, children: T[]) {
    this.id = `location-${location.kuerzel}-${calendarResourceType}`;
    this.name = location.name;
    this.calendarResourceType = calendarResourceType;
    this.background = '#0000000D';
    this.children = children;
    this.seminarrundenAuslastung = location.seminarrundenAuslastung;
  }
}
